import 'src/styles/ui/meta-line.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import iconNode from 'src/components/ui/iconNode';

/**
 * A muted secondary line under a title: a small leading icon + text (e.g. a
 * cadence, timestamp, or status caption). Generic — usable by any feature.
 * `icon` accepts a FontAwesome definition or a node.
 */
const MetaLine = ({ icon, children, className, ...props }) => (
  <div className={classNames('meta-line', className)} {...props}>
    {icon != null && <span className='meta-line__icon'>{iconNode(icon)}</span>}
    {children}
  </div>
);

MetaLine.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  children: PropTypes.node,
  className: PropTypes.string,
};

MetaLine.defaultProps = { icon: null, children: null, className: '' };

export default MetaLine;
